import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H7 from 'UIComponents/elements/headings/H7';
import { jsx as _jsx } from "react/jsx-runtime";
const MissingPermissionState = ({
  selectedAssociationRecord
}) => {
  return /*#__PURE__*/_jsx(UIErrorMessage, {
    className: "m-y-0",
    illustration: "lock",
    illustrationProps: {
      width: 80,
      style: {
        marginBottom: '12px'
      }
    },
    title: /*#__PURE__*/_jsx(H7, {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'universalAssociationsSelect.searchResults.missingPermission.title',
        options: {
          pluralObjectName: selectedAssociationRecord.pluralObjectName
        }
      })
    }),
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'universalAssociationsSelect.searchResults.missingPermission.description'
      })
    })
  });
};
export default MissingPermissionState;